export default "__VITE_ASSET__CRxDSrLI__"